import * as THREE from '@phdsoft/three';
import { Injectable } from "@angular/core";
import { Asset } from 'src/app/platform/busines-data/Framework/Asset';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { Util } from '@phdsoft/common';
import { StructuralElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/StructuralElement';
import { MeshUtils } from '@app/platform/busines-data/Geometries/Utils/mesh-utils';


@Injectable({ providedIn: 'root' })
export class DecalSelectionService {
    private _asset: Asset;
    private camera: THREE.Camera;

    public setCamera(camera: THREE.Camera): void {
        this.camera = camera;
    }

    private GetTypeId(typeName: string): string {
        switch (typeName) {
            case 'Plate':
                return ELEMENTSTYPESIDS.PLATE;
            case 'Stiffener':
                return ELEMENTSTYPESIDS.STIFFENER;
            case 'FacePlate':
                return ELEMENTSTYPESIDS.FACEPLATE;
            case 'Bracket':
                return ELEMENTSTYPESIDS.BRACKET;
            case 'Anode':
                return ELEMENTSTYPESIDS.ANODE;
            case 'Painting':
                return ELEMENTSTYPESIDS.PAINTING;
            default:
                return undefined;
        }
    }

    public setAsset(asset: Asset): void {
        this._asset = asset;
    }

    // TODO LMN_ANODE - CHECK HERE FOR ANODE INSPECTION INSERTION
    public elementsUnderMouse(mouse3D: THREE.Vector3, elementType?: string, currentSectionId?: string): any {
        elementType = this.GetTypeId(elementType); // TODO LMN_ANODE - Verify  elementType for Anode
        if(Util.isNullOrUndefined(elementType))
            elementType = ELEMENTSTYPESIDS.PLATE;
        const raycaster = new THREE.Raycaster();
        const mouse2D = new THREE.Vector2(mouse3D.x, mouse3D.y);
        raycaster.setFromCamera(mouse2D, this.camera);

        const selectableElements =
        this._asset.mode == "MODEL" && this._asset.isLightModel == true ? this._asset.GetVisibleLightModel() : this._asset.GetVisibleGroups().
            filter(x => x.visible)
        if (this._asset.SensorCampaign && this._asset.SensorCampaign.group) {
            selectableElements.push(this._asset.SensorCampaign.group);
        }
    
        const visibleMeshes: THREE.Mesh[] = [];
    
        (selectableElements as THREE.Group[]).forEach(group => {
            group.traverse((obj) => {
            if (obj instanceof THREE.InstancedMesh) return;
            if (
                obj instanceof THREE.Mesh &&
                MeshUtils.isFullyVisible(obj) &&
                ((obj.material as THREE.Material).visible ?? true)
            ) {
                visibleMeshes.push(obj);
            }
            });
        });
    
        // In new model REGIONS mode, structure meshes are hidden (surfaceGroup/linearGroup invisible)
        // but we still need them as raycast targets for inspection insertion
        if (this._asset.isNewModelMode && this._asset.mode === 'REGIONS') {
            for (const region of this._asset.GetStructureAndRepairsVisibleRegions()) {
                for (const section of region.sections) {
                    if (!section.group?.visible) continue;
                    section.surfaceGroup?.traverse(obj => {
                        if (obj instanceof THREE.InstancedMesh) return;
                        if (obj instanceof THREE.Mesh) visibleMeshes.push(obj);
                    });
                    section.linearGroup?.traverse(obj => {
                        if (obj instanceof THREE.InstancedMesh) return;
                        if (obj instanceof THREE.Mesh) visibleMeshes.push(obj);
                    });
                }
            }
        }

        const intersects = raycaster.intersectObjects(visibleMeshes, true)

        const visibleRegions = this._asset.mode === 'MODEL' && this._asset.isLightModel?this._asset.GetStructureVisibleRegionsAndLightModel(): this._asset.GetStructureAndRepairsVisibleRegions();
        visibleRegions.push(...this._asset.GetProtectionElementsVisibleRegions());
        // const intersects = raycaster.intersectObjects(visibleRegions.map(x => x.group), true);
        let intersected = null;
        let intersection = {
            intersects: false,
            point: new THREE.Vector3(),
            normal: new THREE.Vector3(),
            object: new THREE.Object3D(),
            property: null
        };

        const tolerance = 0.01;
        if (intersects.length > 0) {
            if(this._asset.mode == "MODEL" && this._asset.isLightModel == true){
                const intersection = {
                    point: intersects[0].point,
                    object: intersects[0].object,
                    intersects: true,
                    normal: intersects[0].face.normal,
                    property: null
                };
                intersected = intersects[0].object;

                return { intersection, intersected };
              }

            const idsList = intersects.map(x => x.object.name);
            const skipVisibility = this._asset.isNewModelMode && this._asset.mode === 'REGIONS';
            var elements = this._asset.getStructureAndRepairsElements(!skipVisibility).filter(x => (x as StructuralElement).isExecuted);
            const elementTocheck = []

            for (const id of intersects) {
                if (elementType) {
                    var element = elements.find(x => x.SectionId === currentSectionId && x.TypeId === elementType && x.Guid === id.object.name);
                    if (element) {
                        elementTocheck.push({ element: element, intersection: id });
                    }
                }

            }

            const checkDate = elementTocheck.filter(x => Math.abs(x.intersection.distance - elementTocheck[0].intersection.distance) <= tolerance);
            for (const element of checkDate) {
                if(element.element.properties.General.Collection.Date instanceof String)
                    element.element.properties.General.Collection.Date = new Date(element.element.properties.General.Collection.Date);
            }
            var sorted = checkDate.filter(x => x.element.properties).sort((n1, n2) => {
                if (n2.element.properties.General.Collection.Date > n1.element.properties.General.Collection.Date) {
                    return 1;
                }
                if (n2.element.properties.General.Collection.Date < n1.element.properties.General.Collection.Date) {
                    return -1;
                }
                return 0;
            });

            if (sorted && sorted.length > 0) {
                const intersection = {
                    point: sorted[0].intersection.point,
                    object: sorted[0].intersection.object,
                    intersects: true,
                    normal: sorted[0].intersection.face ? sorted[0].intersection.face.normal : sorted[0].element.section.sectionNormal.normalize().clone(),//sectionNormal,
                    property: sorted[0].element.properties
                };
                intersected = sorted[0].intersection.object;

                return { intersection, intersected };
            }

            for (const region of visibleRegions) {
                const section = region.sections.find(x => x.Guid === currentSectionId);
                // for (const section of region.sections)
                if (section) {
                    let surfaceElement = null;
                    let linearElement = null;
                    if (elementType) {
                        for (const id of idsList) {
                            surfaceElement = section?.surfaceElements?.find(x => (x).TypeId === elementType && x.Guid === id);
                            linearElement = section?.linearElements?.find(x => (x).TypeId === elementType && x.Guid === id);
                            if (surfaceElement || linearElement) break;
                        }
                    }
                    else {
                        for (const id of idsList) {
                            surfaceElement = section?.surfaceElements?.find(x => x.Guid === id);
                            linearElement = section?.linearElements?.find(x => x.Guid === id);
                            if (surfaceElement || linearElement) break;
                        }
                    }

                    const resultElement = surfaceElement ?? linearElement;
                    if (resultElement) {
                        const resultIntersection = intersects.find(x => x.object.name === resultElement.Guid);
                        const intersection = {
                            point: resultIntersection.point,
                            object: resultIntersection.object,
                            intersects: true,
                            normal: resultIntersection.face ? resultIntersection.face.normal : section.sectionNormal.normalize().clone(),//sectionNormal,
                            property: resultElement.properties
                        };
                        intersected = resultIntersection.object;

                        return { intersection, intersected };
                    }
                }
            }

            return null;
        }
    }
}
